<template>
    <div class="my-24">
        <div class="flex justify-between">
            <div>
                <h2 v-if="!isRejected" class="text-body font-semibold">{{ $t('settings.vacancy.reasons.request') }}</h2>
                <h2 v-else class="text-body font-semibold">{{ $t('settings.vacancy.reasons.reject') }}</h2>
                <p v-if="!isRejected" class="text-body-sm">{{ $t('settings.vacancy.reasons.request_description') }}</p>
                <p v-else class="text-body-sm">{{ $t('settings.vacancy.reasons.reject_description') }}</p>
            </div>
            <simple-button display="secondary" icon="add-circle" look="primary" @click="create">
                {{ !!isRejected ?
                    $t('settings.vacancy.reject.add') :
                    $t('settings.vacancy.request.add')
                }}
            </simple-button>
        </div>
        <div class="my-32">
            <draggable-transition-group
                :options="reasons"
                :draggable="false"
                label="title"
                :loading="fetchingReasons"
                translatable
                @editing="editing = $event"
                @deleting="deleting = $event"
            />
        </div>

        <job-reason-editor v-if="creating" :reason="creating" @close="stopCreating"></job-reason-editor>
        <job-reason-editor v-if="editing" :reason="editing" @close="stopEdit"></job-reason-editor>

        <popup-modal-confirm
            v-if="deleting"
            :confirm-text="$t('general.delete_subject', {subject: $t('settings.reject_reasons.single')})"
            :message="confirmDeleteMessage(deleting)"
            show-exclamation
            :working="performingDeleteRequest"
            @confirm="deleteReason(deleting)"
            @close="cancelDelete"
        />
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import SvgIcon from './ui/SvgIcon'
import DraggableTransitionGroup from "./ui/DraggableTransitionGroup";
import PopupModalConfirm from "./ui/PopupModalConfirm";
import JobReasonEditor from "./ui/JobReasonEditor";
import * as JobReasonService from "../services/JobReasonService";
import {ADD_NOTIFICATION} from "../state/mutation-types";
import JobReason from "../models/JobReason";
import SimpleButton from "./ui/SimpleButton";
import {mapState, mapActions} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useNotificationsStore} from '../state/modules/notifications';

export default {
    components: {
        Draggable,
        SvgIcon,
        DraggableTransitionGroup,
        PopupModalConfirm,
        JobReasonEditor,
        SimpleButton
    },
    props: {
        fetchingReasons: {type: Boolean, default: false},
        reasons: {type: Array},
        isRejected: {type: Boolean, default: false}
    },
    data() {
        return {
            creating: null,
            editing: null,
            deleting: null,
            performingDeleteRequest: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany', 'selectedLocale']),
        languages() {
            return this.currentCompany.jobsite.active_languages;
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        create() {
            this.creating = useRepo(JobReason).save({is_rejected: !!this.isRejected});
        },
        stopCreating() {
            this.creating = null;
        },
        stopEdit () {
            this.editing = null;
        },
        confirmDeleteMessage (reason) {
            return reason.used ?
                this.$t('settings.reject_reason.used_confirm') :
                this.$t('general.confirm_delete_subject', {subject: this.$t('settings.reject_reasons.single')});
        },
        cancelDelete () {
            this.deleting = null;
        },
        deleteReason (reason) {
            this.performingDeleteRequest = true;

            JobReasonService.destroy(reason.id).then(() => {
                useRepo(JobReason).destroy(reason.id);
            }).then(() => {
                this.deleting = null;
                this.performingDeleteRequest = false;
            }).then(() => {
                this[ADD_NOTIFICATION]({
                    type: 'success',
                    message: this.$t('general.deleted', {subject: this.$t('settings.reject_reasons.single')}),
                });
            });
        },
    },
}
</script>
